/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import t from "react";
const e = t.createContext(void 0), n = () => t.useContext(e);
export {
  e as UnstyledContext,
  n as useUnstyled
};
